export const isGatsbyRoute = (routes: string[], pathname: string) =>
    routes.some((aRoute) => aRoute === pathname || `${aRoute}/` === pathname);
